// Constants for wording
const ZU_DEFAULT_OPTION_TEXT = '-Select a delivery time-';
const ZU_OPTIONS = [
    'Anytime',
    'Tue-Fri (Office addresses; no specific delivery time guaranteed)',
    'Sat (orders placed after Thu 3pm are delivered the following Sat)'
];
const ZU_ALERT_TEXT = 'Please select a delivery time';
const ZU_NOTICE_TEXT = 'Delivery takes 2–5 working days after payment. Delivery times depend on routes and traffic, so we cannot guarantee delivery before 5:30pm or at a specific time. Our customer service will notify you via WhatsApp the day before delivery; please look out for the driver\'s call on the delivery day.';

const EN_DEFAULT_OPTION_TEXT = '-请选择运送时间-';
const EN_OPTIONS = [
    '随时都可以送货',
    '周二至五（Office地址；无法保证具体送达时间）',
    '周六（周四下午3点后下单, 则下周六送达）'
];
const EN_ALERT_TEXT = '请选择运送时间';
const EN_NOTICE_TEXT = '付款后预计2–5个工作日送达。送货时间视路线及交通情况而定，无法保证于下午5:30前或指定时间送达。送货前一天客服会WhatsApp通知您，送货当天请留意司机来电。';



//shopping cart note
$(document).ready(function() {
    //hide checkout from pop out
    var cartNotificationForm = document.getElementById('cart-notification-form');
    if (cartNotificationForm) {
        cartNotificationForm.style.display = 'none';
    }

    // Function to get the active language
    function getActiveLanguage() {
        const activeLanguageLink = document.querySelector('.disclosure__link--active');
        return activeLanguageLink ? activeLanguageLink.getAttribute('data-value') : 'en';
    }

    function initializeCartNote() {
        const activeLanguage = getActiveLanguage();
        var cartNote = document.getElementById('Cart-note');
        var cartNoteLabel = document.querySelector('label[for="Cart-note"]');

        // Remove the textarea element
        if (cartNote) {
            cartNote.remove();
        }

        // Create a dropdown element
        var dropdown = document.createElement('select');
        dropdown.className = 'dropdown field__input';
        dropdown.name = 'note';
        dropdown.id = 'Cart-note-dropdown';
        dropdown.required = true; // Make the field required

        // Add default option
        var defaultOption = document.createElement('option');
        defaultOption.value = '';

        let options, defaultOptionText, alertText, noticeText;

        switch (activeLanguage) {
            case 'zu':
                defaultOptionText = ZU_DEFAULT_OPTION_TEXT;
                options = ZU_OPTIONS;
                alertText = ZU_ALERT_TEXT;
                noticeText = ZU_NOTICE_TEXT;
                break;
            case 'en':
            default:
                defaultOptionText = EN_DEFAULT_OPTION_TEXT;
                options = EN_OPTIONS;
                alertText = EN_ALERT_TEXT;
                noticeText = EN_NOTICE_TEXT;
                break;
        }

        defaultOption.textContent = defaultOptionText;
        defaultOption.disabled = true;
        defaultOption.selected = true;
        dropdown.appendChild(defaultOption);

        // Add other options to the dropdown
        options.forEach(function(optionText) {
            var option = document.createElement('option');
            option.value = optionText;
            option.textContent = optionText;
            dropdown.appendChild(option);
        });

        // Insert the dropdown below the label
        if (cartNoteLabel) {
            cartNoteLabel.parentNode.insertBefore(dropdown, cartNoteLabel.nextSibling);
        }

        // Create and insert the notice message below the "cart__note field" div
        var noticeMessage = document.createElement('p');
        noticeMessage.className = 'notice-message';
        noticeMessage.textContent = noticeText;
        var cartNoteField = document.querySelector('.cart__note.field');
        if (cartNoteField) {
            cartNoteField.parentNode.insertBefore(noticeMessage, cartNoteField.nextSibling);
        }
    }

    function checkCartNoteLoaded() {
        if (document.getElementById('Cart-note')) {
            initializeCartNote();
        } else {
            setTimeout(checkCartNoteLoaded, 100); // Check again after 100ms
        }
    }

    checkCartNoteLoaded();

    // Prevent form submission if the default option is selected
    $('form').on('submit', function(event) {
        const activeLanguage = getActiveLanguage();
        var dropdown = document.getElementById('Cart-note-dropdown');
        if (dropdown && dropdown.value === '') {
            let alertText;
            switch (activeLanguage) {
                case 'zu':
                    alertText = ZU_ALERT_TEXT;
                    break;
                case 'en':
                default:
                    alertText = EN_ALERT_TEXT;
                    break;
            }
            alert(alertText);
            event.preventDefault();
        }
    });
});
